import { Routes, Theme, Users } from "@just-in-types";
import * as moment from "moment";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import Slider from "react-slick";
import Button from "../components/Button";
import Column from "../components/Column";
import Container from "../components/Container";
import LoaderButton from "../components/LoaderButton";
import Modal from "../components/Modal";
import NextButton from "../components/NextButton";
import ResetButton from "../components/ResetButton";
import Row from "../components/Row";
import { ScrollBarCSS } from "../components/ScrollBarCSS";
import Text from "../components/Text";
import Title from "../components/Title";
import ErrorBoundary from "../hoc/withErrorBoundary";
import { RouteComponentProps } from "../Site";
import { setLanguage, SetLanguage, setUserValue, SetUserValue, ToggleCamera, toggleCamera } from "../store/actions";
import { IState } from "../store/reducers";
import { IStrings } from "../store/reducers/strings";

interface ISignatureDispatchProps {
  onSetLanguage: SetLanguage;
  onSetUserValue: SetUserValue;
  onToggleCamera: ToggleCamera;
}

interface ISignatureOwnProps extends RouteComponentProps {
  takeMugshot: boolean;
}

interface ISignatureStateProps {
  languageStrings: IStrings;
  routes: Routes.RoutesObject;
  theme: Theme.Props;
  user: Users.User;
}

type SignatureProps = ISignatureDispatchProps & ISignatureOwnProps & ISignatureStateProps;

interface ISignatureState {
  languageState: string;
  nav1: any;
  nav2: any;
  sending: boolean;
  showSlider: boolean;
  showSmiley: boolean;
  showWaiver: boolean;
  signature: null | string;
  smileyIndex: number;
}

interface INextBtnState {
  nextBtnDisabled : boolean;
  waiverNextBtnDisable: boolean;
}

type SignatureState = ISignatureState & INextBtnState;

const SignatureContainer = styled(Container)`
  grid-template-rows: 30vh 45vh 25vh;
  align-items: center;
`;
const SignatureCanvasContainer = styled("div")`
  position: relative;
  margin: 0 auto;
`;
const WaiverTextWrapper = styled("div")`
  overflow-y: scroll;
  border: 2px solid #444;
  border-radius: 12px;
  padding: 0.5rem;
  max-height: 55vh;
  margin-bottom: 1rem;
  ${(props: { thumbColor: string }) => ScrollBarCSS(props.thumbColor)};
`;

interface SignatureCanvasProps extends HTMLCanvasElement {
  clear: () => void;
  getTrimmedCanvas: () => HTMLCanvasElement;
}

class Signature extends React.Component<SignatureProps, SignatureState> {
  public state: SignatureState = {
    languageState: this.props.user.language,
    nav1: null,
    nav2: null,
    nextBtnDisabled:false,
    sending: false,
    showSlider: true,
    showSmiley: false,
    showWaiver: true,
    signature: null,
    smileyIndex: 0,
    waiverNextBtnDisable:true,
  };
  public signaturePad: null | SignatureCanvasProps = null;

  public slider1: any;
  public slider2: any;

  // setNextBtnValidity

  public constructor(props: SignatureProps) {
    super(props);

    this.setNextBtnValidity = this.setNextBtnValidity.bind(this);
  }

  public setNextBtnValidity(nextBtnState){
    this.setState({ nextBtnDisabled : nextBtnState });
  }

  public clearSignature = () => {
    if (this.signaturePad) {
      this.signaturePad.clear();
    }

    this.setState({ signature: null });
  };

  public getSignature = () => {
    if (this.signaturePad) {
      const signature = this.signaturePad.getTrimmedCanvas().toDataURL();

      this.setState({ signature });
    }
  };

  public componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
    });

    const {
      user: { userId },
    } = this.props;
    if (userId === "opt-out") {
      let lanOpt = "eng";
      if(this.props.user && this.props.user.lanOpt){
        lanOpt = this.props.user.lanOpt;
      }
      this.setState({ languageState: lanOpt });
    }
    document.getElementById('waiver_block').addEventListener('scroll', this.trackScrolling);
    const wrappedElement = document.querySelector<HTMLElement>('#waiver_block')!;

    if(wrappedElement.scrollHeight <= wrappedElement.clientHeight){
      this.setState({ waiverNextBtnDisable:false });
    }

  }

  public trackScrolling = () => {
    const wrappedElement = document.querySelector<HTMLElement>('#waiver_block')!;
    if(wrappedElement.scrollHeight - wrappedElement.scrollTop === wrappedElement.clientHeight){
      this.setState({ waiverNextBtnDisable:false });
    }

  };

  public render() {
    const {
      languageStrings: strings,
      onToggleCamera,
      routes: {
        signature: { takeMugshot, waiverText, waiverTextEs },
      },
      user: { mugshot, hasPaidToday },
      user,
      theme: { colors },
      site: {
        kioskUiAdvDelaySec,
        kioskUiBackgroundColor,
        kioskUiTextColor,
        kioskUiTitleTextColor,
        kioskUiButtonPrimaryColor,
        kioskUiButtonErrorColor,
        kioskUiButtonSuccessColor,
        // kioskUiHideDefaultWaiver,
        kioskUiSigHideAdvIn,
        kioskUiSigHideAdvOut,
        kioskUiSigInAdvFile1,
        kioskUiSigInAdvFile2,
        kioskUiSigInAdvFile3,
        kioskUiSigInAdvFile4,
        kioskUiSigInAdvFile5,
        kioskUiSigInAdvFile6,
        kioskUiSigInAdvFile7,
        kioskUiSigInAdvFile8,
        kioskUiSigInAdvFile9,
        kioskUiSigInAdvFile10,
        kioskUiSigOutAdvFile1,
        kioskUiSigOutAdvFile2,
        kioskUiSigOutAdvFile3,
        kioskUiSigOutAdvFile4,
        kioskUiSigOutAdvFile5,
        kioskUiSigOutAdvFile6,
        kioskUiSigOutAdvFile7,
        kioskUiSigOutAdvFile8,
        kioskUiSigOutAdvFile9,
        kioskUiSigOutAdvFile10,
        kioskUiShowSigSmiley,
        kioskUiWaiverScroll,
        // kioskUiTextEngEditor,
        // kioskUiTextSpnEditor,
      },
      site,
    } = this.props;
    const { languageState, sending, showSmiley, showSlider, showWaiver, signature, smileyIndex, nextBtnDisabled, waiverNextBtnDisable } = this.state;
    const nextButtonDisabled = takeMugshot ? !signature || !mugshot || nextBtnDisabled : !signature;
    const waiver =
      languageState === "esp" && waiverTextEs
        ? waiverTextEs.replace("\n", "<br />")
        : waiverText.replace("\n", "<br />");

    // const curDate = moment().format("MM/DD/YYYY");

    // const firstNameChar = this.props.user.name.firstname.charAt(0);
    // const lastNameChar = this.props.user.name.lastname.charAt(0);


    // if(kioskUiTextSpnEditor && kioskUiTextEngEditor && kioskUiHideDefaultWaiver){ 
    //   const textSpnEditor = kioskUiTextSpnEditor
    //   .replace("_DATE_", curDate)
    //   .replace("_CUSTOMER_NAME_", this.props.user.name.displayName)
    //   .replace(/_FIRSTNAME_/g, firstNameChar.toUpperCase())
    //   .replace(/_LASTNAME_/g, lastNameChar.toUpperCase());
  
    //   const textEngEditor = kioskUiTextEngEditor
    //   .replace("_DATE_", curDate)
    //   .replace("_CUSTOMER_NAME_", this.props.user.name.displayName)
    //   .replace(/_FIRSTNAME_/g, firstNameChar.toUpperCase())
    //   .replace(/_LASTNAME_/g, lastNameChar.toUpperCase());
  
    //   const waiverInteractive = languageState === "esp" && textSpnEditor? textSpnEditor:textEngEditor;

    //   waiver = kioskUiHideDefaultWaiver ? waiverInteractive : waiver;  
    // }

    const switchLanguageText = languageState === "eng" ? "Cambiar a Espanol" : "Change to English";

    const sliderSetting = {
      arrows: false,
      autoplay: true,
      autoplaySpeed: kioskUiAdvDelaySec ? Number(kioskUiAdvDelaySec) : 7000,
      dots: false,
    };
    const kioskUiAdvWidth = site.kioskUiAdvWidth ? site.kioskUiAdvWidth : "300px";
    const kioskUiAdvHeight = site.kioskUiAdvHeight ? site.kioskUiAdvHeight : "200px";
    const kioskUiAdvTop = "10px";
    const kioskUiAdvBottom = site.kioskUiAdvBottom ? site.kioskUiAdvBottom : "20px";

    let smileyTexts = [];
    if (languageState === "eng") {
      smileyTexts = [
        "Smile For The Picture 😊",
        "Say Cheese For The Camera! 😊",
        "Look Serious For The Picture (No Smiling Allowed)",
      ];
    } else {
      smileyTexts = [
        "Sonríe por la foto 😊",
        "Di queso para la cámara! 😊",
        "Mira serio para la foto (no se permite sonreír)",
      ];
    }

    const randomSmileyText = smileyTexts[smileyIndex];

    return (
      <ErrorBoundary>
        <SignatureContainer
          style={{
            background: kioskUiBackgroundColor,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "normal", justifyContent: "space-evenly", width: "100%" }}>
            <div style={{ width: kioskUiAdvWidth }}>
              {!kioskUiSigHideAdvIn && showSlider ? (
                <div>
                  <Slider
                    {...sliderSetting}
                    style={{ width: kioskUiAdvWidth }}
                    asNavFor={this.state.nav2}
                    ref={(slider) => (this.slider1 = slider)}
                  >
                    {kioskUiSigInAdvFile1 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile1}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile2 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile2}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile3 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile3}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile4 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile4}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile5 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile5}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile6 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile6}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile7 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile7}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile8 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile8}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile9 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile9}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigInAdvFile10 && (
                      <div>
                        <img
                          src={kioskUiSigInAdvFile10}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                  </Slider>
                </div>
              ) : (
                "\u00A0"
              )}
            </div>
            <div style={{ textAlign: "center" }}>
              <Title color={kioskUiTitleTextColor ? kioskUiTitleTextColor : kioskUiTextColor}>
                {hasPaidToday ? strings.welcomeBack : strings.pleaseSign}
              </Title>
              {kioskUiShowSigSmiley && showSmiley && (
                <div style={{ margin: "10px 0" }}>
                  <Title size="25px">{randomSmileyText}</Title>
                </div>
              )}
              <SignatureCanvasContainer>
                <SignatureCanvas
                  backgroundColor={"white"}
                  canvasProps={{
                    height: 300,
                    style: {
                      border: `2px solid black`,
                      borderRadius: "12px",
                    },
                    width: 600,
                  }}
                  minWidth={2}
                  maxWidth={5}
                  onEnd={this.getSignature}
                  ref={(ref: SignatureCanvasProps) => (this.signaturePad = ref)}
                  velocityFilterWeight={0.7}
                />
              </SignatureCanvasContainer>
            </div>
            <div style={{ width: kioskUiAdvWidth }}>
              {!kioskUiSigHideAdvOut && showSlider ? (
                <div>
                  <Slider
                    {...sliderSetting}
                    style={{ width: kioskUiAdvWidth }}
                    asNavFor={this.state.nav1}
                    ref={(slider) => (this.slider2 = slider)}
                  >
                    {kioskUiSigOutAdvFile1 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile1}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile2 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile2}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile3 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile3}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile4 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile4}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile5 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile5}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile6 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile6}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile7 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile7}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile8 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile8}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile9 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile9}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                    {kioskUiSigOutAdvFile10 && (
                      <div>
                        <img
                          src={kioskUiSigOutAdvFile10}
                          style={{
                            borderRadius: "12px",
                            height: kioskUiAdvHeight,
                            margin: "auto",
                            width: kioskUiAdvWidth,
                          }}
                        />
                      </div>
                    )}
                  </Slider>
                </div>
              ) : (
                "\u00A0"
              )}
            </div>
          </div>
          <Row align="center" justify="center">
            <ResetButton site={site} />
            <NextButton
              bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
              disabled={nextButtonDisabled}
              name="signature"
              value={signature}
              setNextBtnValidity={this.setNextBtnValidity}
            >
              {strings.addSignature}
            </NextButton>
          </Row>
          {showWaiver && (
            <Modal disableBackdrop={true} onToggleModal={this.toggleWaiverModal}>
              <Button bg={colors.warning} margin={"10px"} size={"1vw"} onClick={this.toggleWaiverLanguage}>
                {switchLanguageText}
              </Button>
              <WaiverTextWrapper id="waiver_block" thumbColor={kioskUiButtonPrimaryColor ? kioskUiButtonPrimaryColor : colors.primary}>
                <div id="inner_waiver_block" dangerouslySetInnerHTML={{ __html: waiver }} />
              </WaiverTextWrapper>
              <Column align="center">
                <Text
                  color={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                  noShadow={true}
                  textAlign="center"
                >
                  {strings.signatureAgreement}
                </Text>
                <LoaderButton
                  bg={kioskUiButtonSuccessColor ? kioskUiButtonSuccessColor : colors.success}
                  loading={sending}
                  onClick={() => {
                    this.toggleWaiverModal();
                    this.openSlider();
                  }}
                  // disabled={kioskUiWaiverScroll?waiverNextBtnDisable:false}
                  size="3.5vmin"
                >
                  {strings.signatureAgreementButton}
                </LoaderButton>
                {process.env.NODE_ENV === "development" && (
                  <Button
                    bg={kioskUiButtonErrorColor ? kioskUiButtonErrorColor : colors.error}
                    onClick={() => onToggleCamera(true)}
                    size="1rem"
                  >
                    Camera
                  </Button>
                )}
              </Column>
            </Modal>
          )}
        </SignatureContainer>
      </ErrorBoundary>
    );
  }

  private toggleWaiverLanguage = async () => {
    let { languageState } = this.state;
    languageState = languageState === "eng" ? "esp" : "eng";
    this.setState({ languageState });

    const {
      onSetLanguage,
      onSetUserValue,
      user: { userId },
    } = this.props;
    if (languageState === "eng") {
      if (userId !== "opt-out") {
        onSetUserValue({ name: "language", value: "eng" });
      }
      onSetLanguage("eng");
    } else {
      if (userId !== "opt-out") {
        onSetUserValue({ name: "language", value: "esp" });
      }
      onSetLanguage("esp");
    }
  };

  private openSlider = () => {
    const {
      user: { userId },
    } = this.props;

    if (userId !== "opt-out") {
      this.setState({ showSlider: true });

      setTimeout(() => {
        this.setState({
          nav1: this.slider1,
          nav2: this.slider2,
        });
      }, 1000);
    }
  };

  private toggleWaiverModal = async () => {
    const {
      onSetUserValue,
      onToggleCamera,
      takeMugshot,
      routes: {
        signature: { waiverText, waiverTextEs },
      },
    } = this.props;

    const { languageState } = this.state;

    const waiver = languageState === "esp" && waiverTextEs ? waiverTextEs : waiverText;
    onSetUserValue({ name: "waiver", value: waiver });
    if (takeMugshot) {
      this.setState({ sending: true });

      onToggleCamera(true);
      this.setState({ showSmiley: true, smileyIndex: Math.floor(Math.random() * 3) });

      this.setState({ sending: false });
    }

    this.setState(({ showWaiver }) => ({ showWaiver: !showWaiver }));
  };
}

const mapStateToProps = ({ router: { languageStrings, routes }, theme, user }: IState) => ({
  languageStrings,
  routes,
  theme,
  user,
});

const mapDispatchToProps = {
  onSetLanguage: setLanguage,
  onSetUserValue: setUserValue,
  onToggleCamera: toggleCamera,
};

export default connect<ISignatureStateProps, ISignatureDispatchProps>(mapStateToProps, mapDispatchToProps)(Signature);



// WEBPACK FOOTER //
// ./src/views/Signature.tsx